import { createApp } from 'vue';
import VideoHeroBlock from './VideoHeroBlock.vue';
import "./VideoHeroTop.scss";

const blocks = document.querySelectorAll('[data-feature="video-hero-block"]');
blocks.forEach(block => {
	if (block) {
		const app = createApp({
			name: 'VideoHeroBlockApp',
		});

		app.component('video-hero-block', VideoHeroBlock);

		app.mount(block);
	}
});

